module.exports = __webpack_public_path__ + "static/media/1008091.0bfa546b.png";